import { Badge } from '@mui/material'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import ButtonGroup from '@mui/material/ButtonGroup'
import Select from '@mui/material/Select'
import { Theme, styled } from '@mui/material/styles'
import { colors, componentSizes } from '@theme/variables'

export const SearchResultsSectionWrapper = styled('div')`
  border-radius: 9px;
  height: 100%;
`

export const SearchResultsSectionInnerWrapper = styled('div')`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  max-width: 1072px;
`

export const SearchResultsTopPanel = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${componentSizes.mdDistance};

  ${(props: { theme: Theme }) => props.theme.breakpoints.down('lg')} {
    flex-direction: column;
    align-items: flex-start;
  }
`

export const TopPaginationWrapper = styled('div')`
  ${(props: { theme: Theme }) => props.theme.breakpoints.down('lg')} {
    margin-bottom: ${componentSizes.smDistance};
  }
`

export const SearchResultsFiltersWrap = styled('div')`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const SearchResultsFilterSelect = styled(Select)`
  background: ${colors.white};
  width: 55%;
  height: 30px;
  margin-top: 5px;

  .MuiOutlinedInput-notchedOutline {
    border-color: ${colors.lightGrey};
  }

  .MuiSelect-select {
    padding: 0 13px;
  }

  & + & {
    margin-left: 12px;
  }
`

export const MetaFilterButtonGroup = styled(ButtonGroup)`
  margin-top: 6px;
  border-radius: 50%;
`

export const MetaFilterButton = styled(Button)`
  border: 1px solid #79747e;
  color: ${colors.black};

  ${({ $active }: { $active: boolean }) =>
    $active
      ? `
          background: rgba(27, 143, 203, 0.12);
        `
      : ''}

  &:hover {
    background: rgba(27, 143, 203, 0.12);
  }
  &:first-of-type {
    border-bottom-left-radius: 50px;
    border-top-left-radius: 50px;
  }
  &:last-of-type {
    border-bottom-right-radius: 50px;
    border-top-right-radius: 50px;
  }
`

export const SearchPlaceholderWrapper = styled(Box)`
  display: flex;
  gap: 18px;
  align-items: center;
  width: 652px;
  padding: 31px 26px;
  margin-top: 76px;
  align-self: center;
  flex-direction: column;
  background: ${colors.white};
  border-radius: 4px;
  border: 1px solid ${colors.lightGrey};

  ${({ theme }: { theme: Theme }) => theme.breakpoints.down('sm')} {
    width: 100%;
    padding: 10px;
    margin-top: 10px;
  }
`

export const SearchIconPlaceholderWrapper = styled('div')`
  font-size: 32px;
  color: ${colors.primary};
  height: 32px;
`

export const SearchTipsWrapper = styled('ul')`
  margin: 0;
  list-style: inside;
  padding: 0 5px;
`

export const SearchTipsItem = styled('li')`
  text-align: center;
  margin-bottom: 10px;
`
export const OperatorTipsWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 18px;
  margin: 4px 0;

  ${({ theme }: { theme: Theme }) => theme.breakpoints.down('sm')} {
    gap: 10px;
  }
`

export const OperatorTipsItem = styled('div')`
  display: flex;
  gap: 19px;
  align-items: center;
  justify-content: center;
  width: 100%;

  ${({ theme }: { theme: Theme }) => theme.breakpoints.down('sm')} {
    gap: 10px;
  }
`
export const OperatorBadgeWrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
`

export const OperatorBadge = styled(Badge)`
  height: 28px;
  width: fit-content;
  color: #fff;
  background-color: ${colors.primary};
  border-radius: 60px;
  font-size: 13px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px 12px;
`

export const AddToShortlistButtonWrapper = styled('div')`
  display: flex;
  border-radius: 18px;
  border: 1px solid;
  padding: 5px 2px 5px 13px;
  height: 30px;
  align-items: center;
  justify-content: center;
  border-color: ${colors.primary};
  color: ${colors.primary};
  gap: 5px;
  box-shadow: 2px 4px 2px 0px #2c607b26;
  background-color: ${colors.white};
  cursor: ${({ $disabled }: { $disabled: boolean }) => ($disabled ? 'inherit' : 'pointer')};
  opacity: ${({ $disabled }: { $disabled: boolean }) => ($disabled ? '0.5' : '1')};
`

export const AddToShortlistButtonText = styled('span')`
  display: inline-block;
  color: ${colors.primary};
`

export const AddToShortlistButtonIconWrapper = styled('span')`
  background-color: ${colors.primary};
  border-radius: 15px;
  color: ${colors.white};
  line-height: 19px;
  padding: 3px 5px;
  display: flex;
  gap: 3px;
  cursor: pointer;
`

export const AddToShorltistLink = styled('span')`
  color: ${colors.primary};
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 100%;
  cursor: pointer;
`
